import React from 'react';
import cn from '../../../../lib/bem';
import img_ok from './../../../../assets/svg/ico_ok.svg';
import ico_cancel_circle from './../../../../assets/svg/ico_cancel_circle.svg';

import './modalConfirmarDatosExito_Component.scss';

const ModalConfirmarDatosExito = (props) => {
  const classes = cn('modalConfirmarDatosExito');

  return (
    <div className={classes('')}>
      <div className={classes('container')}>
        <div className="modalContent">
          <div style={{ position: 'absolute', right: 20 }}>
            <img
              src={ico_cancel_circle}
              alt={'ico_cancel_circle'}
              onClick={() => props.onClose()}
            />
          </div>
          <div className="">
            <div className={classes('contentImg')}>
              <img src={img_ok} alt="img_ok" />
            </div>
            <p className={classes('contentTitle')}>
              <b>Gracias por dejar tus datos.</b>
            </p>
            <p className={classes('contentSubTitle')}>
              Uno de nuestros asesores se contactará contigo.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmarDatosExito;
